import { Box, Typography } from "@mui/material";
import Loader from "components/Loader";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { FormattedMessage as T, useIntl } from "react-intl";
import { Navigate, useNavigate } from "react-router-dom";
import { Organizations } from "@knowfully/ui.common";
import contextStore from "stores/contextStore";
import { EvaluationFormMode } from "types/common-types";
import EvaluationForm from "./EvaluationForm";

const EvaluationCreateForm = () => {
  const { formatMessage: t } = useIntl();
  const { evaluationsUrl } = useGlobalContext();
  const navigate = useNavigate();
  const { organizationId } = contextStore.useState();
  const isRootOrganization =
    organizationId === Organizations.KnowfullyLearningGroup;

  useTitle(`${t({ id: "evaluationFormCreateTitle" })}`);

  const onCancel = () => {
    navigate(evaluationsUrl());
  };

  if (!organizationId) {
    return <Loader />;
  }

  if (isRootOrganization) {
    return <Navigate to={evaluationsUrl()} replace />;
  }

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={evaluationsUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5">
        <T id="evaluationFormCreateTitle" />
      </Typography>
      <EvaluationForm mode={EvaluationFormMode.Create} onCancel={onCancel} />
    </>
  );
};

export default EvaluationCreateForm;
